import { get } from "lodash";

export const UPSELL_WEIGHT = 1;
export const PACK_WEIGHT = 2;

export const QUOTE_SEND_STEP = {
  PRODUCTS: "products",
  UPSELLS: "upsells",
  PACKS: "packs",
};

export const getQuoteSendStep = ({ hasUpsells, hasPacks }) => {
  if (hasPacks) return QUOTE_SEND_STEP.PACKS;
  if (hasUpsells) return QUOTE_SEND_STEP.UPSELLS;
  return QUOTE_SEND_STEP.PRODUCTS;
};

export const shouldSendQuoteAtStep = (step, { hasUpsells, hasPacks }) =>
  getQuoteSendStep({ hasUpsells, hasPacks }) === step;

export const hasOptionalCoverage = ({ hasUpsells, hasPacks }) =>
  Boolean(hasUpsells || hasPacks);

export const shouldContinueToPacks = ({ isPacksStep, hasPacks }) =>
  !isPacksStep && Boolean(hasPacks);

export const getCoverageFlags = (project) => ({
  hasUpsells: Boolean(get(project, "fields.hasUpsells")),
  hasPacks: Boolean(get(project, "fields.hasPacks")),
});

export const getCurrentOptionalCoverageStep = (isPacksStep) =>
  isPacksStep ? QUOTE_SEND_STEP.PACKS : QUOTE_SEND_STEP.UPSELLS;

// Upsells are the additional (non-main) plans of the product's offer with
// weight 1, packs are those with weight 2 — same convention as Solyon.
export const checkProductUpsellsAndPacks = async (
  getOffer,
  insurancePlanId,
) => {
  const { data } = await getOffer({
    variables: {
      where: {
        AND: [
          {
            offerInsurancePlans: {
              insurancePlan: { id: insurancePlanId },
              main: true,
            },
          },
        ],
      },
    },
  });
  const mainOfferId = get(data, "offer.id", null);
  if (!mainOfferId) return { hasUpsells: false, hasPacks: false };

  const { data: offer } = await getOffer({
    fetchPolicy: "no-cache",
    variables: {
      where: {
        AND: [{ id: mainOfferId }, { offerInsurancePlans: { main: false } }],
      },
    },
  });

  const offerInsurancePlans = get(
    offer,
    "offer.offerInsurancePlans",
    [],
  ).filter((plan) => get(plan, "main") !== true);
  return {
    hasUpsells: offerInsurancePlans.some(
      ({ weight }) => weight === UPSELL_WEIGHT,
    ),
    hasPacks: offerInsurancePlans.some(({ weight }) => weight === PACK_WEIGHT),
  };
};

// The Upsells and Packs screens share fields.upsells: each one only replaces
// the modules of its own weight and keeps the other screen's selection.
export const mergeModulesForWeight = ({
  existingModules = [],
  modules = [],
  weight,
}) => [
  ...existingModules.filter((module) => get(module, "weight") !== weight),
  ...modules,
];

export const getMainOfferQueryVariables = (insurancePlanId) => ({
  where: {
    AND: [
      {
        offerInsurancePlans: {
          insurancePlan: { id: insurancePlanId },
          main: true,
        },
      },
    ],
  },
});
